import './StopsSummary.scss';
import { Box, Stack } from '@mui/material';
import { StopProgress } from '../../common/components/stop-progress/stopProgress';
import { RouteBreadcrumb } from '../../common/components/route-breadcrumb/routeBreadcrumb';
import { Stop } from "../../common/apis/dtos";

export interface StopsSummaryProps {
  stops: Stop[];
  isMobileScreen: boolean;
  cargoReady?: string;
  shipmentModeCode: string;
}

export const StopsSummary = ({ stops, isMobileScreen, cargoReady, shipmentModeCode }: StopsSummaryProps) => {
  const sortedStops = [...stops]?.sort((a, b) => a.sequenceNumber - b.sequenceNumber);
  
  return (
    <Stack
      direction="column"
      className="stop-summaries"
      sx={{
        '& .crumb:not(:first-of-type) .stop-data-container': { borderTop: (theme) => `1px solid ${theme.palette.grey[200]}`, },
      }}
    >
      {sortedStops?.map((stop, index) => (
        <Box
          key={`stop-wrapper-${stop.sequenceNumber}`}
          className="crumb"
          display="flex"
          data-testid="shipment-progress-row"
        >
          <RouteBreadcrumb stop={stop} nextStop={stops[index + 1]} />
          <Box key={`stop-${stop.sequenceNumber}`} flexGrow="1">
            <StopProgress stop={stop} isMobileScreen={isMobileScreen} shipmentModeCode={shipmentModeCode} cargoReady={cargoReady} data-testid={`stop-sequenceNumber-${stop.sequenceNumber}`}/>
          </Box>
        </Box>
      ))}
    </Stack>
  );
};